import { FormProvider, useForm } from "react-hook-form";
import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";

import { Container } from "@mui/material";
import DepositDesktop from "./DepositDesktop";
import DepositMobile from "./DepositMobile";
import { GetDeposit } from "store/api/deposit";
import WithdrawOrDepositHistory from "pages/History/WithdrawOrDepositHistory";
import http from "config/http";
import useIsMobileView from "hooks/useIsMobileView";
import useNotify from "hooks/useNotify";

export function Deposit() {
  const [searchParams, setSearchParams] = useSearchParams();
  const type = +searchParams.get("type") || 1;

  const methods = useForm({
    defaultValues: {
      coin: 1,
      type,
      network: null,
      isDigital: true,
    },
  });

  const { setValue } = methods;

  const isMobileView = useIsMobileView();

  const params = useParams();

  const notify = useNotify();

  const [coinList, setCoinList] = useState();

  const getCoinList = async () => {
    try {
      const { data } = await http.get(GetDeposit);

      setCoinList(data?.data);
    } catch (error) {
      notify(error?.response?.data?.message, "error");
    }
  };

  useEffect(() => {
    const idFromUrl = +params.id;

    const currentCoin = coinList?.lisCoin?.find(
      (coin) => coin?.id === idFromUrl
    );

    setValue("coin", currentCoin?.id || 1);
    setValue("isDigital", currentCoin?.isDigital);
  }, [params.id, setValue, coinList?.lisCoin]);

  useEffect(() => {
    getCoinList();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setValue("type", type);
  }, [type, setValue]);

  const selectedCoin = useMemo(() => {
    const idFromUrl = +params.id;

    return coinList?.lisCoin.find((coin) => coin.id === idFromUrl);
  }, [params.id, coinList?.lisCoin]);

  const selectedCoinTypes = useMemo(() => {
    const id = selectedCoin?.id;
    const list = coinList?.lisType;

    const types = list?.filter((item) => item.coinId === id);

    if (types) {
      const checkIfIdExists = types?.find((t) => t?.id === type);

      if (types?.length && !checkIfIdExists) {
        const firstValue = types?.[0]?.id;
        setValue("type", firstValue);
        const allSearchParams = Object.fromEntries([...searchParams]);

        setSearchParams({
          ...allSearchParams,
          type: firstValue,
        });
      }
    }

    return types;
  }, [selectedCoin, coinList, setValue, type, searchParams, setSearchParams]);

  const selectedCoinNetworks = useMemo(() => {
    const filteredNetworks = coinList?.lisWallet?.filter((item) => {
      return +item.coinId === selectedCoin?.id && +item.typeId === type;
    });

    if (filteredNetworks?.length) {
      setValue("network", filteredNetworks?.[0]?.networkId);
    }

    return filteredNetworks;
  }, [coinList, selectedCoin?.id, setValue, type]);

  return (
    <>
      <Container maxWidth="md">
        <FormProvider {...methods}>
          <form>
            {isMobileView ? (
              <DepositMobile
                selectedCoin={selectedCoin}
                coinList={coinList}
                selectedCoinTypes={selectedCoinTypes}
                selectedCoinNetworks={selectedCoinNetworks}
              />
            ) : (
              <DepositDesktop
                selectedCoin={selectedCoin}
                coinList={coinList}
                selectedCoinTypes={selectedCoinTypes}
                selectedCoinNetworks={selectedCoinNetworks}
              />
            )}
          </form>
        </FormProvider>
      </Container>

      {!isMobileView && <WithdrawOrDepositHistory />}
    </>
  );
}
export default Deposit;
